import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: true,
      name: i18n.t('app.yes')
    },
    {
      id: false,
      name: i18n.t('app.no')
    },
    {
      id: null,
      name: i18n.t('app.not_applicable')
    }
  ]
}

export function TIPOS_SEPA_GENERADO (state) {
  return configHelper.getConfig(state, 'TIPOS_SEPA_GENERADO', GenerateConfig)
}
